import { render } from "./UserForm.vue?vue&type=template&id=11d96f15"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=11d96f15&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__